// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__Prdqx","fadeIn":"Footer_fadeIn__zjUoz"};